import { render, staticRenderFns } from "./ExpedienteTipoForm.vue?vue&type=template&id=0d2dbd10&"
import script from "./ExpedienteTipoForm.vue?vue&type=script&lang=js&"
export * from "./ExpedienteTipoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports